import { FileText } from "lucide-react";
import type { CSSProperties } from "react";

const forms = [
  {
    id: "one",
    mark: "N",
    tone: "blue",
    company: "Northstar",
    role: "Frontend Engineer",
    portal: "Workday",
    step: "2 / 6",
    fields: ["Full name", "Experience"],
    left: "-5%",
    top: "10%",
    x: "48vw",
    y: "116vh",
    scale: ".82",
    scaleLift: ".18",
    rotate: "-9deg",
    z: "-110px",
    blur: "1.2px",
    opacity: ".66"
  },
  {
    id: "two",
    mark: "P",
    tone: "violet",
    company: "Paperplane",
    role: "Product Engineer",
    portal: "Greenhouse",
    step: "3 / 7",
    fields: ["Education", "Current city"],
    left: "6%",
    top: "38%",
    x: "37vw",
    y: "89vh",
    scale: ".97",
    scaleLift: ".03",
    rotate: "-5deg",
    z: "45px",
    blur: "0px",
    opacity: ".9"
  },
  {
    id: "three",
    mark: "K",
    tone: "slate",
    company: "Kernel",
    role: "Software Engineer",
    portal: "Darwinbox",
    step: "1 / 8",
    fields: ["Legal name", "Notice period"],
    left: "18%",
    top: "4%",
    x: "26vw",
    y: "122vh",
    scale: ".7",
    scaleLift: ".3",
    rotate: "7deg",
    z: "-170px",
    blur: "1.8px",
    opacity: ".54"
  },
  {
    id: "four",
    mark: "D",
    tone: "cobalt",
    company: "Daybreak",
    role: "UI Engineer",
    portal: "Lever",
    step: "4 / 6",
    fields: ["Portfolio", "Core skills"],
    left: "28%",
    top: "63%",
    x: "16vw",
    y: "63vh",
    scale: "1.06",
    scaleLift: "-.06",
    rotate: "-3deg",
    z: "95px",
    blur: "0px",
    opacity: ".96"
  },
  {
    id: "five",
    mark: "M",
    tone: "indigo",
    company: "Monsoon",
    role: "Full-stack Engineer",
    portal: "PeopleStrong",
    step: "2 / 5",
    fields: ["Resume", "Availability"],
    left: "68%",
    top: "8%",
    x: "-24vw",
    y: "118vh",
    scale: ".76",
    scaleLift: ".24",
    rotate: "8deg",
    z: "-135px",
    blur: "1.35px",
    opacity: ".61"
  },
  {
    id: "six",
    mark: "O",
    tone: "cyan",
    company: "Orbit",
    role: "Platform Engineer",
    portal: "SAP SuccessFactors",
    step: "3 / 8",
    fields: ["Current role", "Work permit"],
    left: "82%",
    top: "33%",
    x: "-38vw",
    y: "93vh",
    scale: ".98",
    scaleLift: ".02",
    rotate: "5deg",
    z: "60px",
    blur: "0px",
    opacity: ".92"
  },
  {
    id: "seven",
    mark: "A",
    tone: "blue",
    company: "Atlas",
    role: "Data Analyst",
    portal: "iCIMS",
    step: "1 / 5",
    fields: ["Education", "Experience"],
    left: "94%",
    top: "12%",
    x: "-50vw",
    y: "114vh",
    scale: ".68",
    scaleLift: ".32",
    rotate: "11deg",
    z: "-190px",
    blur: "2px",
    opacity: ".5"
  },
  {
    id: "eight",
    mark: "V",
    tone: "violet",
    company: "Vela",
    role: "Design Engineer",
    portal: "SmartRecruiters",
    step: "5 / 7",
    fields: ["Portfolio", "Why this role?"],
    left: "74%",
    top: "65%",
    x: "-30vw",
    y: "61vh",
    scale: "1.03",
    scaleLift: "-.03",
    rotate: "4deg",
    z: "105px",
    blur: "0px",
    opacity: ".96"
  },
  {
    id: "nine",
    mark: "G",
    tone: "cyan",
    company: "Grove",
    role: "Graduate Engineer",
    portal: "Oracle Taleo",
    step: "2 / 9",
    fields: ["Graduation year", "Location"],
    left: "2%",
    top: "70%",
    x: "42vw",
    y: "56vh",
    scale: ".75",
    scaleLift: ".25",
    rotate: "-7deg",
    z: "-90px",
    blur: ".9px",
    opacity: ".7"
  },
  {
    id: "ten",
    mark: "L",
    tone: "cobalt",
    company: "Lattice",
    role: "QA Engineer",
    portal: "Zoho Recruit",
    step: "3 / 6",
    fields: ["Testing tools", "Current city"],
    left: "90%",
    top: "70%",
    x: "-46vw",
    y: "56vh",
    scale: ".78",
    scaleLift: ".22",
    rotate: "9deg",
    z: "-75px",
    blur: ".75px",
    opacity: ".72"
  },
  {
    id: "eleven",
    mark: "R",
    tone: "indigo",
    company: "Relay",
    role: "Backend Engineer",
    portal: "Cornerstone",
    step: "2 / 7",
    fields: ["Primary stack", "Experience"],
    left: "35%",
    top: "15%",
    x: "9vw",
    y: "111vh",
    scale: ".7",
    scaleLift: ".3",
    rotate: "-2deg",
    z: "-155px",
    blur: "1.6px",
    opacity: ".56"
  },
  {
    id: "twelve",
    mark: "C",
    tone: "slate",
    company: "Canopy",
    role: "Product Designer",
    portal: "Custom employer portal",
    step: "4 / 8",
    fields: ["Portfolio URL", "Work samples"],
    left: "58%",
    top: "17%",
    x: "-14vw",
    y: "109vh",
    scale: ".72",
    scaleLift: ".28",
    rotate: "3deg",
    z: "-145px",
    blur: "1.45px",
    opacity: ".58"
  }
] as const;

export function HeroApplicationStorm() {
  return (
    <div className="hero-storm" aria-hidden="true">
      <svg className="hero-storm__routes" viewBox="0 0 1440 900" preserveAspectRatio="none">
        <path d="M-80 110C230 80 430 390 950 1090" />
        <path d="M-60 440C250 420 510 680 950 1090" />
        <path d="M30 820C320 820 630 900 950 1090" />
        <path d="M390 -40C470 270 650 700 950 1090" />
        <path d="M1050 -40C1075 285 1030 730 950 1090" />
        <path d="M1510 130C1240 120 1130 520 950 1090" />
        <path d="M1500 470C1260 465 1100 750 950 1090" />
        <path d="M1430 830C1230 855 1080 930 950 1090" />
      </svg>

      {forms.map((form) => (
        <span
          className={`hero-storm__sheet hero-storm__sheet--${form.id}`}
          key={form.id}
          style={{
            "--storm-left": form.left,
            "--storm-top": form.top,
            "--storm-x": form.x,
            "--storm-y": form.y,
            "--storm-scale": form.scale,
            "--storm-scale-lift": form.scaleLift,
            "--storm-rotate": form.rotate,
            "--storm-z": form.z,
            "--storm-blur": form.blur,
            "--storm-opacity": form.opacity
          } as CSSProperties}
        >
          <span className="hero-storm__paper">
            <span className="hero-storm__paper-head">
              <i className={`hero-storm__mark hero-storm__mark--${form.tone}`}>{form.mark}</i>
              <span>
                <strong>{form.role}</strong>
                <small>{form.portal} · application</small>
              </span>
              <b>{form.step}</b>
            </span>
            <span className="hero-storm__field-grid">
              {form.fields.map((field, index) => (
                <span className="hero-storm__field" key={field}>
                  <small>{field}</small>
                  <i className={index === 1 ? "is-short" : ""} />
                </span>
              ))}
            </span>
            <span className="hero-storm__field hero-storm__field--long">
              <small>Why are you interested in this role?</small>
              <i />
            </span>
            <span className="hero-storm__paper-foot">
              <span><FileText size={11} strokeWidth={1.8} /> Resume attached</span>
              <b>{form.company}</b>
            </span>
          </span>
        </span>
      ))}
    </div>
  );
}
